import { Component } from '@angular/core';

@Component({
  selector: 'app-instructor-details',
  templateUrl: './instructor-details.component.html'
})
export class InstructorDetailsComponent {}
